import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks/useAuth/useAuth';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';
import LoginForm from 'components/LoginForm/';
import Spinner from 'components/Spinner';
import OntruckLogo from 'assets/icons/OntruckLogo';
import TermsAndConditionsModal from 'components/TermsAndConditionsModal';
import useDocsCarrierProfile from 'hooks/useDocsCarrierProfile/useDocsCarrierProfile';

const Login = ({ className }) => {
  const { t } = useTranslation('Login');
  const {
    profile,
    termsAccepted,
    loading,
    accessToken,
    error,
    signin,
    signInWithToken,
    acceptTermsAndConditions,
  } = useAuth();
  const { clearCarrierProfile } = useDocsCarrierProfile();
  let history = useHistory();
  let location = useLocation();

  const handleSubmit = (e, user, password) => {
    e.preventDefault();
    signin(user, password);
    clearCarrierProfile();
  };

  useEffect(() => {
    if (!profile && location.state?.queryToken && !loading && !error) {
      signInWithToken(location.state?.queryToken);
      location.state.queryToken = null;
    }
  }, [profile, location.state, signInWithToken, loading, error]);

  useEffect(() => {
    if (termsAccepted) {
      let { from, source } = location.state || {
        from: { pathname: ROUTES.OFFERS },
      };
      from.state = { ...from.state, source };
      history.replace(from);
    }
  }, [termsAccepted, history, location.state]);

  return (
    <div className={className} data-testid="login">
      <div className="login">
        <div className="login__container">
          {!loading && !accessToken && (
            <>
              <div className="login__logo">
                <OntruckLogo />
              </div>
              <h1 className="login__title" data-testid="login__title">
                {t('title')}
              </h1>
              {error && (
                <div className="login__error" data-testid="login__error">
                  {t('login_error')}
                </div>
              )}
              <LoginForm handleSubmit={handleSubmit} disabled={loading} />
              <Link className="login__recovery" to={ROUTES.PASSWORD_RECOVERY}>
                {t('forgotPassword')}
              </Link>
            </>
          )}
          {loading && (
            <div className="login__loading" data-testid="login__loading">
              <Spinner />
            </div>
          )}
        </div>
      </div>
      <TermsAndConditionsModal
        onAccept={acceptTermsAndConditions}
        isShowing={!loading && !!profile && !termsAccepted}
        tcLink={
          profile?.user?.country_settings?.links?.carrier_term_and_conditions ||
          ''
        }
      />
    </div>
  );
};

export default Login;
